const TAIL_SIZE = 50

export default {
  count (state) {
    return state.logs.length
  },

  tails (state) {
    const items = []
    const first = state.logs.length - 1
    const last = Math.max(0, first - TAIL_SIZE)
    for (let i = first; i >= last; --i) {
      items.push(state.logs[i])
    }
    return items
  }
}
